<template>
  <div>

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="user === undefined"
    >
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'apps-users-list'}"
        >
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>

    <template v-if="user">
      <!-- First Row -->
      <b-row>
        <b-col
          cols="12"
          xl="9"
          lg="8"
          md="7"
        >
          <user-view-user-info-card :user-data="user" />
        </b-col>
        <b-col
          cols="12"
          md="5"
          xl="3"
          lg="4"
        >
          <user-view-user-plan-card />
        </b-col>
      </b-row>

    </template>

  </div>
</template>

<script>
import {
  BRow, BCol, BAlert, BLink,
} from 'bootstrap-vue'
import User from '@/models/user'

import UserViewUserInfoCard from './UserViewUserInfoCard.vue'
import UserViewUserPlanCard from './UserViewUserPlanCard.vue'

import { getUserData } from '@/auth/utils'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,
    UserViewUserInfoCard,
    UserViewUserPlanCard,
  },
  setup() {
    return {
      user: getUserData(),
    }
  },
}
</script>

<style>

</style>
